import { render, staticRenderFns } from "./comment_templates_modal.vue.js?vue&type=template&id=fe967644!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_templates_modal.vue?vue&type=template&id=fe967644"
import script from "./comment_templates_modal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_templates_modal.vue?vue&type=script&lang=js"
export * from "./comment_templates_modal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./comment_templates_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports